import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["task", "search", "noMatches", "toggleAll"]

  connect() {
    this.refreshToggleAll()
  }

  filter() {
    const searchTerm = this.searchTarget.value.trim().toLowerCase()
    let matchCount = 0

    this.taskTargets.forEach((task) => {
      const matches = task.dataset.searchText.includes(searchTerm)
      task.classList.toggle("hidden", !matches)
      if (matches) matchCount += 1
    })

    this.noMatchesTarget.classList.toggle("hidden", matchCount > 0)
    this.refreshToggleAll()
  }

  toggleTask(event) {
    const task = event.currentTarget.closest("[data-preferred-contacts-target~='task']")
    this.setExpanded(task, !this.isExpanded(task))
    this.refreshToggleAll()
  }

  toggleAll(event) {
    event.preventDefault()
    const tasks = this.visibleTasks()
    const shouldExpand = !tasks.some((task) => this.isExpanded(task))

    tasks.forEach((task) => this.setExpanded(task, shouldExpand))
    this.refreshToggleAll()
  }

  isExpanded(task) {
    return !task.querySelector("[data-preferred-contacts-detail]").classList.contains("hidden")
  }

  setExpanded(task, expanded) {
    task.querySelector("[data-preferred-contacts-detail]").classList.toggle("hidden", !expanded)
    task.querySelector("[data-preferred-contacts-chevron]").classList.toggle("rotate-90", expanded)
    task.querySelector("[data-preferred-contacts-trigger]").setAttribute("aria-expanded", expanded)
  }

  visibleTasks() {
    return this.taskTargets.filter((task) => !task.classList.contains("hidden"))
  }

  refreshToggleAll() {
    const tasks = this.visibleTasks()
    const hasExpandedTask = tasks.some((task) => this.isExpanded(task))
    this.toggleAllTarget.textContent = hasExpandedTask ? "Collapse all" : "Expand all"
  }
}
